import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import I18n from 'i18n'
import { User } from 'graphqlAPI'
import { joinKeys } from 'helpers/translations.helper'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import coursesReminder from 'api/administration/participants/coursesReminder'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { prefixTranslation } from './common'
import { DropdownButton } from 'components/ui/DropdownButton'

interface IProps {
  user: User
}

const Options: React.FC<IProps> = ({ user }) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)

  const { id, allCoursesProgress } = user
  const handleDropdownClick = (show: boolean) => {
    setShow(show)
  }

  return (
    <DropdownButton
      show={show}
      alignRight
      title={<DropdownLoader loading={loading} />}
      onClick={() => handleDropdownClick(!show)}
      onToggle={() => handleDropdownClick(!show)}
    >
      <Link to={`/configuration/user/${id}`}>
        {t(joinKeys(prefixTranslation, 'view'))}
      </Link>
      <Dropdown.Item
        disabled={
          !(allCoursesProgress?.pending || allCoursesProgress?.inProgress)
        }
        onClick={async () => {
          try {
            await coursesReminder(id)
            SuccessToast(I18n.t('administration.toastMessages.coursesReminder'))
          } catch (e) {
            ErrorToast(
              I18n.t('administration.toastMessages.coursesReminderError')
            )
          }
        }}
      >
        {t(joinKeys(prefixTranslation, 'sendReminder'))}
      </Dropdown.Item>
    </DropdownButton>
  )
}

export default Options
